import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
import { Rating } from "@mui/material";
import { toUpper } from "lodash";
import { useNavigate } from "react-router-dom";

const dummyTopics = [
  {
    id: 1,
    user: "",
    title: "The picture is not displaying properly",
    feedback: "The Yi Home Mobile app is unable to pair with the camera",
    isAdmin: false,
  },
  {
    id: 2,
    user: "",
    title: "Unable to display video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 3,
    user: "",
    title: "The images are not playing in my video",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
  {
    id: 4,
    user: "",
    title: "The picture is not displaying properly",
    messages: [],
    feedback: "",
    isAdmin: true,
  },
];

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

export default function InteractiveList(props: any) {
  const { Topfivetickets, ReportsTicketsTopfiveCount } = props;
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const navigate = useNavigate();

  const handleRedirectUncategorisedTickets = () => {
    // navigate("/tickets");
    const stateObj = {
      pageType: "mainReportPage",
    };
    navigate(`/view-uncategorized-ticket`, { state: stateObj });
  };

  return (
    <Grid
      item
      xs={3}
      md={12}
      sx={{ border: "1px solid #ccc", borderRadius: "8px" }}
    >
      <Typography className="repu-heading">
        <Typography sx={{ fontWeight: 700, fontSize: "13px" }}>
          UNCATEGORIZED TICKETS
          <Avatar
            sx={{
              height: "35px",
              width: "35px",
              marginLeft: "5px",
              fontSize: "10px",
              background: "#2858D3",
              display: "inline-flex",
              border: "1px solid #FFF",
            }}
          >
            {ReportsTicketsTopfiveCount}
          </Avatar>
        </Typography>
        <Typography
          sx={{
            color: "#2858D3",
            fontWeight: 700,
            fontSize: "13px",
            cursor: "pointer",
          }}
          component="div"
          onClick={() => handleRedirectUncategorisedTickets()}
        >
          VIEW TICKETS
        </Typography>
      </Typography>
      <List dense={dense}>
        {Topfivetickets &&
          Topfivetickets.length > 0 &&
          Topfivetickets.map((value: any) => (
            <ListItem
            // secondaryAction={
            //   <IconButton edge="end" aria-label="delete">
            //     <Rating name="read-only" value={3} readOnly />
            //   </IconButton>
            // }
            >
              <ListItemAvatar>
                {/* <Avatar sx={{ height: "40px", width: "40px" }}>
                  <img src="https://source.unsplash.com/user/c_v_r/400x400" />
                </Avatar> */}
                {value.profilePic && (
                  <img className="prod-logo" src={value.profilePic} />
                )}

                {!value.profilePic && (
                  <Typography className="prod-logo-txt">
                    <Avatar
                      sx={{
                        fontSize: "15px",
                        background: "#2858D3",
                        display: "inline-flex",
                        border: "1px solid #FFF",
                      }}
                    >
                      {value?.userId?.charAt(0).toUpperCase()}
                    </Avatar>
                  </Typography>
                )}
              </ListItemAvatar>
              <ListItemText
                className="feedbmetricrepu-mail"
                sx={{ fontSize: "10px" }}
                primary={
                  <>
                    <p style={{ margin: "0px", fontWeight: 500 }}>
                      {value.userId}
                    </p>
                    <p
                      style={{
                        margin: "0px",
                        fontSize: "12px",
                        color: "#000000a6",
                      }}
                    >
                      {value && value.topics && value.topics.length > 0
                        ? value.topics[0]
                        : "Raised via chatbot"}
                    </p>
                  </>
                }
                secondary={secondary ? "Secondary text" : null}
              />
            </ListItem>
          ))}
      </List>
    </Grid>
  );
}
